/* eslint-disable @typescript-eslint/no-this-alias -- Shopify theme asset in the theme's ES5 style: `var self = this` is how its callbacks reach the element. */
/**
 * ET Mega Menu (2026-09-24)
 * Vanilla JS controller for <et-mega-menu>. Only loaded when
 * section.settings.etm_enable is true (see sections/header.liquid).
 *
 * Markup contract (rendered by snippets/et-mega-menu.liquid):
 *   <et-mega-menu class="etm ...">
 *     <button class="etm-burger main-menu__toggle" aria-controls="etm-drawer-<id>">
 *     <div class="etm-content main-menu__content">
 *       <nav class="etm-bar">
 *         <button class="etm-item" data-panel="all|guides|m0|m1..." aria-controls="etm-panel-...">
 *         <a class="etm-item etm-item--link" href="...">                 (leaf top-level links)
 *       </nav>
 *     </div>
 *     <div class="etm-scrim">
 *     <div class="etm-panels">
 *       <div class="etm-panel" data-panel="...">
 *         <div class="etm-rail"> <a class="etm-rail-item" data-parent="m0" data-index="0">
 *         <div class="etm-cat-group" data-parent="m0" data-index="0">   (middle zone per category)
 *         <div class="etm-side-group" data-parent="m0" data-index="0">  (right rail per category)
 *         <input class="etm-idx-input">                                  (A-Z filter, panel "all" only)
 *     <div class="etm-drawer">
 *       <div class="etm-drawer-level" data-level="root|m0|c0-1|...">
 *         <button data-drawer-open="m0">, <button data-drawer-back>, <button data-drawer-close>
 *
 * Behavior implemented here: hover-intent open/close with "menu aim", click + keyboard
 * support, scrim dismissal, rail hover switching, A-Z type-to-filter with highlighting,
 * and the phone drill-down drawer with body-scroll lock. Respects prefers-reduced-motion
 * by shortening the open/close delays (the CSS itself removes the animated transitions).
 */
(function () {
  'use strict';

  if (customElements.get('et-mega-menu')) return;

  var OPEN_DELAY = 140;
  var CLOSE_DELAY = 300;
  var AIM_DELAY = 260;
  var AIM_MIN_DELAY = 40;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    OPEN_DELAY = 0;
    CLOSE_DELAY = 0;
    AIM_DELAY = 0;
    AIM_MIN_DELAY = 0;
  }

  /* ---------- Buy Again card helpers ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function etmEsc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function etmDate(iso) {
    if (!iso) return null;
    var p = String(iso).slice(0, 10).split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function etmShortDate(iso) {
    var d = etmDate(iso);
    if (!d) return '';
    var s = MONTHS[d.getMonth()] + ' ' + d.getDate();
    return d.getFullYear() === new Date().getFullYear() ? s : s + ', ' + d.getFullYear();
  }
  function etmGap(days) {
    if (!days) return '';
    if (days < 14) return 'usually every ~' + days + ' days';
    if (days < 63) return 'usually every ~' + Math.round(days / 7) + ' weeks';
    return 'usually every ~' + Math.round(days / 30) + ' months';
  }
  function etmDueText(iso) {
    var d = etmDate(iso);
    if (!d) return 'Due now';
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var n = Math.round((d - today) / 86400000);
    if (n <= 0) return 'Due now';
    return n === 1 ? 'Due tomorrow' : 'Due in ' + n + ' days';
  }
  function etmImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function etmCard(x, mini) {
    var meta = [];
    if (x.due) meta.push('<b>' + etmDueText(x.next_due) + '</b>');
    if (x.last) meta.push('Last ordered ' + etmShortDate(x.last));
    if (!mini && x.gap) meta.push(etmGap(x.gap));
    var img = x.image
      ? '<img src="' + etmEsc(etmImg(x.image, mini ? 96 : 128)) + '" alt="" loading="lazy" width="64" height="64">'
      : '<span class="etm-noimg"></span>';
    return '<a class="etm-ba-card' + (mini ? ' etm-ba-card--mini' : '') + (x.due ? ' is-due' : '') + '" href="/products/' + etmEsc(x.handle) + '">' +
      img +
      '<span class="etm-ba-body">' +
        (mini ? '' : '<span class="etm-ba-sku">' + etmEsc(x.sku) + '</span>') +
        '<span class="etm-ba-t">' + etmEsc(x.title) + '</span>' +
        '<span class="etm-ba-k">' + meta.join(' &middot; ') + '</span>' +
      '</span>' +
      (mini ? '' : '<span class="etm-ba-go">Reorder &rarr;</span>') +
    '</a>';
  }

  var EtMegaMenu = (function () {
    function EtMegaMenu(el) {
      this.el = el;
      this.bar = el.querySelector('.etm-bar');
      this.scrim = el.querySelector('.etm-scrim');
      this.panelsHost = el.querySelector('.etm-panels');
      this.items = Array.prototype.slice.call(el.querySelectorAll('.etm-item[data-panel]'));
      this.panels = Array.prototype.slice.call(el.querySelectorAll('.etm-panel'));
      this.openKey = null;
      this.openTimer = null;
      this.closeTimer = null;
      this.aimTimer = null;
      this.lastPoints = [];
      this.activeTrigger = null;

      this.bindBar();
      this.bindPanels();
      this.bindIndexFilter();
      this.bindDrawer();
      this.bindGlobal();
      this.loadMe();
    }

    EtMegaMenu.prototype.getPanel = function (key) {
      return this.el.querySelector('.etm-panel[data-panel="' + key + '"]');
    };

    EtMegaMenu.prototype.bindBar = function () {
      var self = this;
      if (!this.bar) return;

      this.items.forEach(function (btn) {
        var key = btn.dataset.panel;

        btn.addEventListener('mouseenter', function () {
          window.clearTimeout(self.closeTimer);
          window.clearTimeout(self.openTimer);
          var delay = self.openKey ? 0 : OPEN_DELAY;
          self.openTimer = window.setTimeout(function () {
            self.open(key, btn);
          }, delay);
        });

        btn.addEventListener('mouseleave', function () {
          window.clearTimeout(self.openTimer);
        });

        // Items with data-href are also links to their department page.
        // Mouse: hover opens the panel, a click goes to the page (cmd/ctrl-click
        // opens it in a new tab). Touch has no hover: the first tap opens the
        // panel, a tap on the open item goes. "All Categories" has no page.
        var href = btn.dataset.href;
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();
          if (href && (evt.metaKey || evt.ctrlKey)) {
            window.open(href, '_blank');
            return;
          }
          if (href && evt.pointerType === 'mouse') {
            window.location.href = href;
            return;
          }
          window.clearTimeout(self.openTimer);
          // A tap that lands just after hover-intent opened this panel is the
          // same gesture — keep it open instead of acting on it again.
          if (self.openKey === key && Date.now() - (self.openedAt || 0) < 600) return;
          if (self.openKey === key) {
            if (href) {
              window.location.href = href;
              return;
            }
            self.close();
            btn.focus();
          } else {
            self.open(key, btn);
          }
        });

        btn.addEventListener('keydown', function (evt) {
          if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
            evt.preventDefault();
            if (self.openKey === key) {
              if (href && evt.key === 'Enter') {
                window.location.href = href;
                return;
              }
              self.close();
            } else {
              self.open(key, btn);
            }
          }
        });
      });

      this.bar.addEventListener('mouseleave', function () {
        self.scheduleClose();
      });
    };

    EtMegaMenu.prototype.bindPanels = function () {
      var self = this;
      this.panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () {
          window.clearTimeout(self.closeTimer);
        });
        panel.addEventListener('mouseleave', function () {
          self.scheduleClose();
        });
        panel.addEventListener('mousemove', function (evt) {
          self.lastPoints.push([evt.clientX, evt.clientY]);
          if (self.lastPoints.length > 4) self.lastPoints.shift();
        });

        var rails = Array.prototype.slice.call(panel.querySelectorAll('.etm-rail-item'));
        rails.forEach(function (rail) {
          var go = function () {
            self.selectCategory(panel, rail.dataset.parent, rail.dataset.index);
          };
          rail.addEventListener('mouseenter', function () {
            window.clearTimeout(self.aimTimer);
            if (rail.classList.contains('is-active')) return;
            var main = panel.querySelector('.etm-main') || panel;
            var mainRect = main.getBoundingClientRect();
            var pts = self.lastPoints;
            var a = pts[0];
            var b = pts[pts.length - 1];
            var heading = false;
            if (a && b) {
              var dx = b[0] - a[0];
              var dy = Math.abs(b[1] - a[1]);
              heading = dx > 2 && dy < dx * 2.2 && b[0] < mainRect.left;
            }
            self.aimTimer = window.setTimeout(go, heading ? AIM_DELAY : AIM_MIN_DELAY);
          });
          rail.addEventListener('mouseleave', function () {
            window.clearTimeout(self.aimTimer);
          });
          // Rail items are real links to the category collection. A mouse click
          // follows the link (hover already previewed it). On touch there is no
          // hover, so the first tap previews and a tap on the selected item goes.
          rail.addEventListener('click', function (evt) {
            var isMouse = evt.pointerType === 'mouse';
            if (isMouse || rail.classList.contains('is-active')) return;
            evt.preventDefault();
            go();
          });
          rail.addEventListener('keydown', function (evt) {
            if (evt.key === ' ' || (evt.key === 'Enter' && !rail.classList.contains('is-active'))) {
              evt.preventDefault();
              go();
            }
          });
        });
      });
    };

    EtMegaMenu.prototype.selectCategory = function (panel, parent, index) {
      var railScroll = panel.querySelector('.etm-rail');
      var scrollTop = railScroll ? railScroll.scrollTop : 0;

      panel.querySelectorAll('.etm-rail-item[data-parent="' + parent + '"]').forEach(function (r) {
        r.classList.toggle('is-active', r.dataset.index === index);
      });
      panel.querySelectorAll('.etm-cat-group[data-parent="' + parent + '"]').forEach(function (g) {
        g.classList.toggle('is-active', g.dataset.index === index);
      });
      panel.querySelectorAll('.etm-side-group[data-parent="' + parent + '"]').forEach(function (g) {
        g.classList.toggle('is-active', g.dataset.index === index);
      });

      if (railScroll) railScroll.scrollTop = scrollTop;
    };

    // "More below" cue: only when the category list is taller than the window allows.
    EtMegaMenu.prototype.updateRailMore = function (panel) {
      if (!panel) return;
      var rail = panel.querySelector('.etm-rail');
      if (!rail || !rail.querySelector('.etm-rail-more')) return;
      rail.classList.toggle('has-more', rail.scrollHeight - rail.scrollTop - rail.clientHeight > 12);
      if (!rail.dataset.etmMoreBound) {
        var self = this;
        rail.dataset.etmMoreBound = '1';
        rail.addEventListener('scroll', function () { self.updateRailMore(panel); }, { passive: true });
      }
    };

    EtMegaMenu.prototype.open = function (key, trigger) {
      window.clearTimeout(this.closeTimer);
      var panel = this.getPanel(key);
      if (!panel) return;

      if (this.openKey && this.openKey !== key) {
        var prev = this.getPanel(this.openKey);
        if (prev) prev.classList.remove('is-active');
      }

      if (this.openKey !== key) this.openedAt = Date.now();
      if (key === 'all' && this.openKey !== 'all') {
        var idxInput = panel.querySelector('.etm-idx-input');
        if (idxInput) window.setTimeout(function () { idxInput.focus({ preventScroll: true }); }, 60);
      }
      this.openKey = key;
      this.activeTrigger = trigger || this.activeTrigger;
      this.place();
      this.el.classList.add('is-open');
      panel.classList.add('is-active');
      this.updateRailMore(panel);

      this.items.forEach(function (btn) {
        var on = btn.dataset.panel === key;
        btn.classList.toggle('is-open', on);
        btn.classList.toggle('etm-item--light', on && btn.dataset.light === '1');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    };

    EtMegaMenu.prototype.close = function () {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.aimTimer);
      if (!this.openKey) return;
      var panel = this.getPanel(this.openKey);
      if (panel) panel.classList.remove('is-active');
      this.openKey = null;
      this.el.classList.remove('is-open');
      this.items.forEach(function (btn) {
        btn.classList.remove('is-open', 'etm-item--light');
        btn.setAttribute('aria-expanded', 'false');
      });
    };

    // The panels and scrim hang off the bottom of the bar in CSS (top: 100%), so they move with
    // the sticky header on their own. Here we only stretch them from .etm's left edge to the
    // full window width, and tell the panel how much height is left below the bar.
    EtMegaMenu.prototype.place = function () {
      var rect = this.el.getBoundingClientRect();
      var width = document.documentElement.clientWidth;
      this.el.style.setProperty('--etm-left', -rect.left + 'px');
      this.el.style.setProperty('--etm-width', width + 'px');
      this.el.style.setProperty('--etm-top', Math.max(0, rect.bottom) + 'px');
    };

    EtMegaMenu.prototype.scheduleClose = function () {
      var self = this;
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(function () {
        self.close();
      }, CLOSE_DELAY);
    };

    EtMegaMenu.prototype.bindGlobal = function () {
      var self = this;
      var follow = function () {
        if (self.openKey) self.place();
      };
      // Place once now and on every resize, not only while open: until place() runs, the hidden
      // scrim sits at .etm's left edge with a full-window width, so it hangs past the right edge
      // and widens the page (an iPad pinch-zoom then pans into a blank strip beside the header).
      this.place();
      window.addEventListener('scroll', follow, { passive: true });
      window.addEventListener('resize', function () {
        self.place();
        if (self.openKey) self.updateRailMore(self.getPanel(self.openKey));
      });
      if (this.scrim) {
        this.scrim.addEventListener('click', function () {
          self.close();
        });
      }
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') {
          if (self.openKey) {
            var trigger = self.activeTrigger;
            self.close();
            if (trigger) trigger.focus();
          }
          self.closeDrawer();
        }
      });
      document.addEventListener('click', function (evt) {
        if (!self.openKey) return;
        if (self.el.contains(evt.target)) return;
        self.close();
      });
    };

    /* ---------- A-Z index filter ---------- */
    EtMegaMenu.prototype.bindIndexFilter = function () {
      var panel = this.getPanel('all');
      if (!panel) return;
      var input = panel.querySelector('.etm-idx-input');
      if (!input) return;
      var meta = panel.querySelector('.etm-idx-meta');
      var empty = panel.querySelector('.etm-idx-empty');
      var depts = Array.prototype.slice.call(panel.querySelectorAll('.etm-idx-dept'));

      var mark = function (el, q) {
        var original = el.dataset.title;
        if (!q) {
          el.textContent = original;
          return;
        }
        var lower = original.toLowerCase();
        var i = lower.indexOf(q);
        if (i < 0) {
          el.textContent = original;
          return;
        }
        el.textContent = '';
        el.appendChild(document.createTextNode(original.slice(0, i)));
        var m = document.createElement('mark');
        m.textContent = original.slice(i, i + q.length);
        el.appendChild(m);
        el.appendChild(document.createTextNode(original.slice(i + q.length)));
      };

      var run = function () {
        var q = input.value.trim().toLowerCase();
        var visibleDepts = 0;
        var visibleCats = 0;

        depts.forEach(function (dept) {
          var deptTitle = (dept.dataset.title || '').toLowerCase();
          var deptHit = !q || deptTitle.indexOf(q) > -1;
          var deptHasVisibleCat = false;

          Array.prototype.forEach.call(dept.querySelectorAll('.etm-idx-cat'), function (cat) {
            var l2 = cat.querySelector('.etm-idx-l2');
            var catTitle = (l2 && l2.dataset.title || '').toLowerCase();
            var catHit = !q || deptHit || catTitle.indexOf(q) > -1;
            var subHitAny = false;

            Array.prototype.forEach.call(cat.querySelectorAll('.etm-idx-l3'), function (sub) {
              var subTitle = (sub.dataset.title || '').toLowerCase();
              var subHit = !q || catHit || subTitle.indexOf(q) > -1;
              if (subHit) subHitAny = true;
              sub.hidden = !subHit;
              mark(sub, q);
            });

            var showCat = catHit || subHitAny;
            cat.hidden = !showCat;
            if (showCat) {
              deptHasVisibleCat = true;
              visibleCats++;
            }
            if (l2) mark(l2, q);
          });

          dept.hidden = !deptHasVisibleCat;
          if (deptHasVisibleCat) visibleDepts++;
        });

        if (empty) empty.hidden = visibleDepts > 0;
        if (meta) {
          meta.textContent = q
            ? visibleCats + ' categories match'
            : visibleCats + ' categories · ' + visibleDepts + ' departments';
        }
      };

      input.addEventListener('input', run);
      run();

      panel.addEventListener('transitionend', function () {
        if (panel.classList.contains('is-active')) {
          input.focus({ preventScroll: true });
        }
      });
    };

    /* ---------- signed-in shopper: bought / due marks + Buy Again ----------
     * Only when Liquid saw a customer (data-me-api on the root). The Toolbox app
     * (GET /apps/toolbox/api/menu, through the Shopify app proxy, which signs the
     * request with the customer id) answers from the nightly order-history
     * snapshots. Cached per tab for 10 minutes. Any failure leaves the menu as a
     * guest sees it. */
    EtMegaMenu.prototype.loadMe = function () {
      var api = this.el.dataset.meApi;
      if (!api || !window.fetch) return;
      var self = this;
      var key = 'etm-me:' + (this.el.dataset.me || '');
      var cached = null;
      try { cached = JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch { cached = null; }
      if (cached && cached.me && cached.at > Date.now() - 600000) {
        this.applyMe(cached.me);
        return;
      }
      fetch(api, { credentials: 'same-origin', headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (me) {
          if (!me || !me.signed_in) return;
          try { window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), me: me })); } catch { /* private mode */ }
          self.applyMe(me);
        })
        .catch(function () { /* menu stays as a guest sees it */ });
    };

    EtMegaMenu.prototype.applyMe = function (me) {
      var bought = me.bought || {};
      var due = me.due || {};
      var again = Array.isArray(me.again) ? me.again : [];

      // Departments and trades hold almost everything, so a chip there says nothing.
      var skip = {};
      (this.el.dataset.meSkip || '').split(',').forEach(function (h) { if (h.trim()) skip[h.trim()] = true; });
      this.el.querySelectorAll('.etm-item[data-href], a.etm-item').forEach(function (b) {
        var m = (b.getAttribute('data-href') || b.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
        if (m) skip[decodeURIComponent(m[1])] = true;
      });

      var noChip = ['etm-btn', 'etm-push', 'etm-ad', 'etm-guide', 'etm-tcard', 'etm-prod', 'etm-dr-row--viewall', 'etm-item'];
      this.el.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
        if (!m) return;
        var h = decodeURIComponent(m[1]);
        if (skip[h]) return;
        var kind = due[h] ? 'due' : bought[h] ? 'bought' : null;
        if (!kind) return;
        for (var i = 0; i < noChip.length; i++) if (a.classList.contains(noChip[i])) return;
        if (a.closest('.etm-more-note')) return;
        // The A-Z filter rewrites these links' text, so they get a CSS-drawn chip.
        if (a.classList.contains('etm-idx-l2') || a.classList.contains('etm-idx-l3')) {
          a.classList.add('etm-me-' + kind);
          return;
        }
        var host = a.querySelector('.etm-title') || (a.classList.contains('etm-tile') && a.querySelector('.etm-ph')) || a.querySelector('b');
        if (!host) {
          for (var j = 0; j < a.children.length; j++) {
            var c = a.children[j];
            if (c.tagName === 'SPAN' && !/etm-(noimg|arr|n|ph)\b/.test(c.className)) { host = c; break; }
          }
        }
        if (!host || host.querySelector('.etm-chip')) return;
        var chip = document.createElement('span');
        chip.className = 'etm-chip etm-chip--' + kind;
        chip.textContent = kind === 'due' ? 'Reorder due' : 'Bought before';
        host.appendChild(chip);
      });

      if (!again.length) return;
      var dueItems = again.filter(function (x) { return x.due; });
      var recent = again.filter(function (x) { return !x.due; });

      var bar = this.el.querySelector('.etm-item--buy');
      if (bar) {
        bar.hidden = false;
        var pip = bar.querySelector('.etm-pip');
        if (pip && dueItems.length) {
          pip.textContent = String(dueItems.length);
          pip.title = dueItems.length === 1 ? '1 item due for reorder' : dueItems.length + ' items due for reorder';
          pip.hidden = false;
        }
      }

      var fill = function (el, items, empty) {
        if (!el) return;
        el.innerHTML = items.length ? items.map(function (x) { return etmCard(x, false); }).join('') : '<p class="etm-ba-empty">' + empty + '</p>';
      };
      fill(this.el.querySelector('[data-etm-ba-due]'), dueItems, me.active === false
        ? 'Welcome back. Your past orders are listed here so they are easy to find again.'
        : 'Nothing due this week. When your usual reorder time comes up, it shows here.');
      fill(this.el.querySelector('[data-etm-ba-recent]'), recent, 'Your recent orders will show here.');

      var strip = this.el.querySelector('[data-etm-ba-strip]');
      var cards = this.el.querySelector('[data-etm-ba-cards]');
      if (strip && cards) {
        cards.innerHTML = dueItems.concat(recent).map(function (x) { return etmCard(x, true); }).join('');
        strip.hidden = false;
      }
    };

    /* ---------- phone drawer ---------- */
    EtMegaMenu.prototype.bindDrawer = function () {
      var self = this;
      this.drawer = this.el.querySelector('.etm-drawer');
      this.burger = this.el.querySelector('.etm-burger');
      if (!this.drawer || !this.burger) return;

      this.drawerLevels = Array.prototype.slice.call(this.drawer.querySelectorAll('.etm-drawer-level'));
      this.drawerStack = ['root'];

      this.burger.addEventListener('click', function () {
        if (self.drawer.classList.contains('is-open')) {
          self.closeDrawer();
        } else {
          self.openDrawer();
        }
      });

      this.drawer.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();
          self.pushDrawerLevel(btn.dataset.drawerOpen);
        });
      });
      this.drawer.querySelectorAll('[data-drawer-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.popDrawerLevel();
        });
      });
      this.drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closeDrawer();
        });
      });
    };

    EtMegaMenu.prototype.showDrawerLevel = function (id) {
      this.drawerLevels.forEach(function (lvl) {
        lvl.classList.toggle('is-active', lvl.dataset.level === id);
      });
    };

    EtMegaMenu.prototype.pushDrawerLevel = function (id) {
      var target = this.drawer.querySelector('.etm-drawer-level[data-level="' + id + '"]');
      if (!target) return;
      this.drawerStack.push(id);
      this.showDrawerLevel(id);
      var scroller = target.querySelector('.etm-dr-scroll');
      if (scroller) scroller.scrollTop = 0;
    };

    EtMegaMenu.prototype.popDrawerLevel = function () {
      if (this.drawerStack.length <= 1) return;
      this.drawerStack.pop();
      var id = this.drawerStack[this.drawerStack.length - 1];
      this.showDrawerLevel(id);
    };

    EtMegaMenu.prototype.openDrawer = function () {
      this.drawerStack = ['root'];
      this.showDrawerLevel('root');
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('etm-drawer-open');
    };

    EtMegaMenu.prototype.closeDrawer = function () {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('etm-drawer-open');
      this.burger.focus();
    };

    return EtMegaMenu;
  })();

  customElements.define(
    'et-mega-menu',
    class extends HTMLElement {
      connectedCallback() {
        if (!this.etmInstance) {
          this.etmInstance = new EtMegaMenu(this);
        }
      }
    }
  );
})();
